import * as angular from 'angular';

class FeesCtrl implements ng.IController {
    public auction: AuctionDetailDto;
    public tsoRange: Array<string>;

    constructor() {}

    $onInit(): void {
        if (this.auction.networkPoint.bundled) {
            this.tsoRange = ['0', '1'];
        } else {
            this.tsoRange = ['0'];
        }
    }
}

angular.module('app').component('pkpFees', {
    controller: FeesCtrl,
    template: require('app/_directives/fees.component.html'),
    require: {},
    bindings: {
        auction: '='
    }
});
